import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {topicalityReport_template} from "../components/templates/topicalityReport_template";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";

declare var ko: any;
declare var page: any;

export class topicalityReport extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected topicalityReport_template: topicalityReport_template;

    protected getModuleName(){
        return "topicalityReport";
    }

    buildContent() : Array<Element>{

        this.topicalityReport_template = new topicalityReport_template( "topicalityReport", this.viewModel, this );

        this.template = this.topicalityReport_template;

        return [this.topicalityReport_template.build()];
    }

    public fillPage() : void{

        this.topicalityReport_template.buildDatePickerCalendar();

        this.getSearchPresetsListData();
    }

    public getListFormData(): void{

        this.loadingIn(this.topicalityReport_template.builtTemplate);

        let usrReq_url: string = '/api/topicalityReport/references/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON([])] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetListFormDataReturn;
        this.XHRHdl.execute();
    }

    protected onGetListFormDataReturn(req, obj){

        return function(){

            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                if(  req.request.status == 200  ){

                    obj.updateFilters(responseParsed.data);
                    obj.updateViewModelFromPath();
                    obj.getReportData();
                }
            });

            obj.loadingOut(obj.topicalityReport_template.builtTemplate);
        }
    }

    public getReportData(): void{

        this.loadingIn(this.topicalityReport_template.builtTemplate.children.namedItem("list-results"));
        this.topicalityReport_template.getTemplateViewModel().isReportLoading(1);

        let subViewModel = this.topicalityReport_template.getViewModelForRequest();
        let baseApiUrl = '/api/topicalityReport/get/';

        this.sendFilterCall(baseApiUrl, subViewModel, this.onGetReportData, XMLHttpRequestHandler_requestType.GET, 'getReportData');
    }

    protected onGetReportData(req, obj) {

        return function () {

            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                if (req.request.status == 200) {

                    obj.updateList(responseParsed);
                }
            });

        }
    }

    protected updateFilters(responseParsed: any) {

        this.topicalityReport_template.setViewModesItems();
        this.topicalityReport_template.setBrandsItems(responseParsed.departments);
        this.topicalityReport_template.setInitiativesItems(responseParsed.initiatives);
        this.topicalityReport_template.setIntentsItems(responseParsed.intents);
        this.topicalityReport_template.setContentTypesItems(responseParsed.groupedContentTypes);
        this.topicalityReport_template.setDataSourcesItems();
        this.topicalityReport_template.setGoogleSourcesItems();
        this.topicalityReport_template.setTableHeaderItems();
    }

    protected updateList(responseParsed: any) {

        this.topicalityReport_template.resetSelectedRows();
        this.topicalityReport_template.setTableData(responseParsed.data);

        // update the paginator
        this.topicalityReport_template.setPaginationTotalCount(responseParsed.totalCount);

        this.topicalityReport_template.getTemplateViewModel().isReportLoading(0);
        this.loadingOut(this.topicalityReport_template.builtTemplate.children.namedItem("list-results"));
    }

    protected reportFinishedLoading() {

    }

    protected filterSingleDateOnChange() {

        this.resetPageNumber();
        this.getReportData();
    }

    protected filterMultipleSelectorOnChange(id) {

        // Unselect primary category when selecting or unselecting brands
        if (id == 'filterBrands'){

            this.topicalityReport_template.resetPrimaryCategoriesFilter();
        }

        this.resetPageNumber();
        this.getReportData();
    }

    protected filterDateOnChange() {

        this.resetPageNumber();
        this.getReportData();
    }

    protected filterSimpleOnChange() {

        this.resetPageNumber();
        this.getReportData();
    }

    protected filterDropdownOnChange(){

        this.resetPageNumber();
        this.getReportData();
    }

    public dataReorder(id) {

        this.getReportData();
    }

    protected getMultipleAutoCompleteSuggestions(id, keyword) {

        let subViewModel = {
            filters      : {
                keyword : keyword,
                idBrands : this.topicalityReport_template.getTemplateViewModel().filterBrands.selectedItems(),
                idPrimaryCategories : this.topicalityReport_template.getTemplateViewModel().primaryCategoriesFilter.selectedItemIds(),
                startDate: this.topicalityReport_template.getTemplateViewModel().filterDates.startDate(),
                endDate: this.topicalityReport_template.getTemplateViewModel().filterDates.endDate(),
                view: 'tag',
            }
        };

        let usrReq_url: string = '';
        let usrReq_callback;
        switch (id){

            case 'filterTags':{

                usrReq_url = '/api/topicalityReport/getTagSuggestions/';
                usrReq_callback = this.onGetAutoCompleteTagsSuggestionsReturn;
                break;
            }

            case 'filterTagTypes':{

                usrReq_url = '/api/topicalityReport/getTagTypeSuggestions/';
                usrReq_callback = this.onGetAutoCompleteTagTypesSuggestionsReturn;
                break;
            }

            case 'primaryCategoriesFilter':{

                usrReq_url = '/api/topicalityReport/emakiCategorySuggestions/';
                usrReq_callback = this.onGetAutoCompleteCategoriesSuggestionsReturn;
                break;
            }
        }

        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = usrReq_callback;
        this.XHRHdl.execute();
    }

    protected onGetAutoCompleteCategoriesSuggestionsReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);
                if(req.request.status == 200){

                    obj.topicalityReport_template.setPrimaryCategoriesFilterItems(responseParsed.data);
                }
            });
        }
    }

    protected onGetAutoCompleteTagsSuggestionsReturn(req, obj){

        return function () {

            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                if (req.request.status == 200) {

                    obj.topicalityReport_template.setTagsItems(responseParsed.data);
                }
            });
        }
    }

    protected onGetAutoCompleteTagTypesSuggestionsReturn(req, obj){

        return function () {

            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                if (req.request.status == 200) {

                    obj.topicalityReport_template.setTagTypesItems(responseParsed.data);
                }
            });
        }
    }

    protected paginationOnPageClick(){

        this.getReportData();
    }

    private resetPageNumber(){

        // go back to page 1 in the pagination
        this.topicalityReport_template.resetPageNumber();
    }

    public getExportData(): void{

        this.loadingIn(this.topicalityReport_template.builtTemplate.children.namedItem("list-results"));

        this.XHRHdl.cancelAndReset();

        let subViewModel = this.topicalityReport_template.getViewModelForRequest();

        let usrReq_url: string = '/api/topicalityReport/export/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetExportData;
        this.XHRHdl.execute();
    }

    protected onGetExportData(req, obj){

        return function () {

            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                if (req.request.status == 200) {

                    obj.topicalityReport_template.validationsList.clearMessages();
                    obj.topicalityReport_template.setExportData(responseParsed);
                    obj.topicalityReport_template.exportData();
                }
            });

            obj.loadingOut(obj.topicalityReport_template.builtTemplate.children.namedItem("list-results"));
        }
    }
}



// WEBPACK FOOTER //
// ./js/modules/topicalityReport.ts